import { Spin } from 'antd';
import useURLs from 'hooks/use-url';

export default function ContactButton(): JSX.Element {
  const urls = useURLs();

  if (!urls) {
    return <Spin />;
  }

  return (
    <a target='_blank' rel='noopener noreferrer' href={urls.contact.url} className='ant-btn ant-btn-default ant-btn-lg'>
      Contact us
    </a>
  );
}
